import { CircularProgress, Stack } from "@mui/material";

export default function LoadingPage() {
  return (
    <Stack
      direction={"row"}
      width={"100%"}
      height={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress size={100} />
    </Stack>
  );
}
